<template>
  <div class="message-box dialog-mask" @click="focusOut">
    <div class="dialog-content">
      <header>{{ title }}</header>
      <div class="dialog-body">
        <div v-html="content"></div>
      </div>
      <footer>
        <div class="button-area">
          <button class="button cancel" @click="$close(false)">{{ cancelButton || $t("common.cancel") }}</button>
          <button class="button danger" @click="$close(true)">{{ okButton || $t("common.yes") }}</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    title: String,
    content: String,
    okButton: {
      type: String,
      default: undefined,
    },
    cancelButton: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    cancel() {
      this.$close(false);
    },
    focusOut(e) {
      // if (e.target.classList.contains("dialog-mask")) {
      //   //  this.$close(false);
      // }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

header {
  font-weight: var(--font-weight-bold);
  font-size: large;
  margin: 15px auto;
  color: var(--color-text-normal);
}

.button-area {
  margin: 10px auto;
  float: right;
  display: flex;
  gap: 10px;
}

.button {
  position: relative;
  padding: 8px 20px;
  border-radius: 5px;
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: filter 0.2s ease;

  &.cancel {
    background-color: var(--color-surface-muted);
    color: var(--color-text-normal);
    border: 1px solid var(--color-border);

    @include hover-overlay;
  }

  &.danger {
    background-color: var(--color-warning);
    color: var(--color-text-on-fixed-bg);
    border: none;

    @include hover-overlay;
  }
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dialog-body {
  font-size: larger;
  color: var(--color-text-normal);
}

.dialog-mask {
  position: fixed;
  top: -100px;
  right: 0;
  bottom: 0;
  left: 0;
  display: -ms-flexbox;
  display: flex;
  z-index: 9000;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: var(--color-overlay);
}

.dialog-content {
  margin: 0 10px;
  padding: 10px 15px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  background-color: var(--color-background-normal);
  box-shadow: var(--shadow-lg);
  color: var(--color-text-normal);
}
</style>
